/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import placementTestActions from '../../../redux/actions/placementTestActions';

const useStyles = makeStyles(() => ({
  button: {
    marginTop: '2em',
  },
}));

const NextButton = ({
  pushAnswer, currentAnswer, currentQuestion, setCurrentQuestion,
}) => {
  const classes = useStyles();

  const handleNext = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    pushAnswer();
    setCurrentQuestion(currentQuestion + 1);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleNext}
      disabled={currentAnswer.length === 0}
      className={classes.button}
      fullWidth
    >
      Submit
    </Button>
  );
};

NextButton.propTypes = {
  currentQuestion: PropTypes.number.isRequired,
  currentAnswer: PropTypes.array.isRequired,
  setCurrentQuestion: PropTypes.func.isRequired,
  pushAnswer: PropTypes.func.isRequired,
};

const actionCreators = {
  setCurrentQuestion: placementTestActions.setCurrentQuestion,
  pushAnswer: placementTestActions.pushAnswer,
};

function mapState(state) {
  const { currentQuestion, currentAnswer } = state.placementTest;
  return {
    currentQuestion, currentAnswer,
  };
}
export default connect(mapState, actionCreators)(NextButton);
